export default "__VITE_ASSET__BqP9W0m$__"